/* eslint-disable @typescript-eslint/camelcase */
import * as actions from './PDFActions';

const initialState = {
  downloadErrors: null,
  savedReportsPath: null,
};

const PDF = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_CLAIMS:
      return Object.assign({}, state, {
        [action.clientId]: {
          ...state[action.clientId],
          canSaveTemplate: action.canSaveTemplate,
          canDeleteTemplate: action.canDeleteTemplate,
          canGeneratePdf: action.canGeneratePdf,
          enhancedReportExperience: action.enhancedReportExperience,
        },
      });

    case actions.SET_PDF_INFO: {
      const { base, templates: _templates, name, pdfModel, isFirmLevelTemplate } = action.info;

      const templates = _templates || state[action.clientId].templates;

      const { sessionSections } = action;

      const localTn = templates.map(template => ({
        label: template.name,
        value: template.name,
        isFirmLevelTemplate: template.isFirmLevelTemplate,
      }));

      localTn.unshift({ label: 'Default Template', value: 0 });

      const sections = {
        included: base ? base.includedSections : pdfModel.includedSections,
        excluded: base ? base.excludedSections : pdfModel.excludedSections,
      };

      // This intends to preserve the current edited sections while the Adviser stays on the page
      if (sessionSections) {
        let targetSection = null;
        Object.keys(sections).forEach(section => {
          const array = sections[section];
          for (let i = 0; i < array.length; i++) {
            if (array[i].type === 'CoverPage') {
              targetSection = array[i];
            }
          }
        });

        Object.keys(sessionSections).forEach(section => {
          const array = sessionSections[section];
          for (let i = 0; i < array.length; i++) {
            if (array[i].type === 'CoverPage') {
              targetSection.editableFields = array[i].editableFields;
            }
          }
        });
      }

      return {
        ...state,
        [action.clientId]: {
          ...state[action.clientId],
          name,
          isFirmLevelTemplate,
          sections: {
            ...sections,
            included: sections.included.map((section, index) => ({ ...section, id: index })),
          },
          template_names: templates ? localTn : state[action.clientId].template_names,
          templates,
          downloading: false,
        },
      };
    }

    case actions.ADD_TEMPLATE: {
      const localTemplateNames = state[action.clientId].template_names
        ? state[action.clientId].template_names.filter(({ label }) => label !== action.name)
        : [];

      const localTemplates = [
        ...state[action.clientId].templates.filter(({ name }) => name !== action.name),
        {
          name: action.name,
          ...action.template,
        },
      ];

      localTemplateNames.push({
        label: action.name,
        value: action.name,
        isFirmLevelTemplate: action.isFirmLevelTemplate,
      });

      localTemplateNames.sort((a, b) =>
        a.label === 'Default Template'
          ? -1
          : a.label.toLowerCase() < b.label.toLowerCase()
          ? -1
          : 1,
      );

      return {
        ...state,
        [action.clientId]: {
          ...state[action.clientId],
          name: action.name,
          template_names: localTemplateNames,
          templates: localTemplates,
        },
      };
    }
    case actions.SET_DOWNLOADING:
      return Object.assign({}, state, {
        [action.clientId]: {
          ...state[action.clientId],
          downloading: action.downloading,
        },
      });
    case actions.SET_ERRORS:
      return Object.assign({}, state, {
        [action.clientId]: {
          ...state[action.clientId],
          errors: action.errors,
        },
      });
    case actions.SET_WARNINGS:
      return Object.assign({}, state, {
        [action.clientId]: {
          ...state[action.clientId],
          warnings: action.warnings,
        },
      });
    case actions.DELETE_SECTION: {
      let local_sections = clone(state[action.clientId].sections);
      local_sections[action.list === 'included' ? action.list : 'excluded'].splice(action.index, 1);
      return Object.assign({}, state, {
        [action.clientId]: {
          ...state[action.clientId],
          sections: local_sections,
        },
      });
    }
    case actions.REMOVE_ITEM: {
      const { remove_list, index } = action;
      let local_included = clone(state[action.clientId].sections.included);
      if (remove_list === 'included') local_included.splice(index, 1);
      let local_excluded = clone(state[action.clientId].sections.excluded);
      if (remove_list === 'excluded') local_excluded.splice(index, 1);
      return Object.assign({}, state, {
        [action.clientId]: {
          ...state[action.clientId],
          sections: {
            included: local_included,
            excluded: local_excluded,
          },
        },
      });
    }
    case actions.ADD_ITEM: {
      const { add_list, item: itemWithoutId, position } = action;
      const hasPosition = position || position === 0;
      let target = null;

      if (add_list === 'included') target = state[action.clientId].sections.included;
      if (add_list === 'excluded') target = state[action.clientId].sections.excluded;

      const nextId = Math.max(...target.map(({ id }) => id));
      const item = { ...itemWithoutId, id: nextId + 1 };

      if (target) {
        if (!hasPosition) {
          target = clone(target);
          target.push(item);
        } else {
          target = [...target.slice(0, position), item, ...target.slice(position)];
        }
      }

      return {
        ...state,
        [action.clientId]: {
          ...state[action.clientId],
          sections: {
            ...state[action.clientId].sections,
            [add_list]: target,
          },
        },
      };
    }
    case actions.MOVE_ITEM: {
      const { move_list, drag_index, hover_index } = action;
      let move_item;
      let local_included = state[action.clientId].sections.included.slice();
      if (move_list === 'included') {
        move_item = local_included.splice(drag_index, 1);
        local_included.splice(hover_index, 0, move_item[0]);
      }
      let local_excluded = state[action.clientId].sections.excluded.slice();
      if (move_list === 'excluded') {
        move_item = local_excluded.splice(drag_index, 1);
        local_excluded.splice(hover_index, 0, move_item[0]);
      }
      return Object.assign({}, state, {
        [action.clientId]: {
          ...state[action.clientId],
          sections: {
            included: local_included,
            excluded: local_excluded,
          },
        },
      });
    }
    case actions.CHANGE_ITEM:
      return {
        ...state,
        [action.clientId]: {
          ...state[action.clientId],
          sections: {
            ...state[action.clientId].sections,
            [action.list]: state[action.clientId].sections[action.list].map(item => {
              if (item.id === action.item.id) {
                return action.item;
              }

              return item;
            }),
          },
        },
      };

    case actions.SET_DOWNLOAD_ERRORS:
      return {
        ...state,
        downloadErrors: action.errors,
      };

    case actions.SET_DOC_VAULT_PATH:
      return {
        ...state,
        savedReportsPath: action.payload,
      };
    default:
      return state;
  }
};

export default PDF;
